import React from "react";

const PartnerSpecialCard = ({ label, logo, name, subtitle }) => {
  return (
    <div className="flex flex-col items-center group">
      <h4 className="text-[11px] font-black uppercase text-blue-600 dark:text-blue-400 mb-8 tracking-[0.4em]">
        {label}
      </h4>
      <div className="h-32 flex items-center justify-center mb-6">
        <img 
          src={logo} 
          alt={name}
          className="h-20 md:h-24 lg:h-28 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <p className="text-xl font-bold text-slate-900 dark:text-white uppercase tracking-tighter">
        {name}
      </p>
      <p className="text-xs text-slate-400 font-medium italic mt-2">
        {subtitle}
      </p>
    </div>
  );
};

export default PartnerSpecialCard;